import { NavLink } from "react-router-dom";
import classNames from 'classnames';
import TabBarTab from "./navigationElements/TabBarTab";

const TabBar = ({ className = "", tabs }) => {
  return (
    <div className={classNames("px-4 sm:px-0", className)}>
      <div className="sm:hidden">
        <label htmlFor="question-tabs" className="sr-only">
          Select a tab
        </label>
        <select
          id="question-tabs"
          className="block w-full rounded-md border-gray-300 text-base font-medium text-gray-900 shadow-sm focus:border-rose-500 focus:ring-rose-500"
        >
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <nav
          className="relative z-0 rounded-lg shadow flex divide-x divide-gray-200"
          aria-label="Tabs"
        >
          {tabs.map((tab, tabIdx) => (
            <NavLink
              key={tabIdx}
              to={tab.to}
              // TODO: Improve link disabling
              onClick={(event) => tab.disabled && event.preventDefault()}
              disabled={tab.disabled}
              className={classNames(
                "group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-6 text-sm font-medium text-center hover:bg-gray-50 focus:z-10",
                {
                  "cursor-not-allowed bg-gray-50": tab.disabled,
                  "rounded-l-lg": tabIdx === 0,
                  "rounded-r-lg": tabIdx === tabs.length - 1
                }
              )}
            >
              {({ isActive }) =>
                <TabBarTab tab={tab} isActive={isActive} />
              }
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default TabBar;
